import { create } from "zustand";

interface TableHeadStore {
  tableHeadActive: boolean | null;
  setTableHeadActive: (isActive: boolean) => void;
}

export const useTableHeadStore = create<TableHeadStore>()((set) => ({
  tableHeadActive: null,
  setTableHeadActive: (isActive) => set({ tableHeadActive: isActive })
}));
